import styled from 'styled-components'

export const DashboardContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  /* border: 1px solid red; */
  /* max-width: 1400px; */
  width: 100%;
  margin: 0 auto 1.375rem auto;
`
export const ManagementCards = styled.div`
  display: flex;
  width: 100%;
  /* margin-top: 1.5rem; */
  /* padding-top: 1.37rem; */
  padding-bottom: 1.37rem;
  gap: 1rem;
  /* justify-content: space-between; */
  flex-wrap: wrap;
  @media (max-width: 700px) {
    flex-direction: column;
    width: 100%;
  }
`
export const ManagementOneCard = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: ${(props) => props.theme.colorWhite};
  box-shadow: 0 0 1.875rem rgba(0, 0, 0, 0.15);
  border-radius: 0.875rem;
  padding: 1.375rem;
  width: calc(50% - 0.5rem);
  @media (max-width: 700px) {
    width: 100%;
  }
`
